import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import categoryQuery from '~/graphql/category.gql';
import { extractCategoryHash, buildCategoryProductsQuery } from '~/helpers/extract-helper';
import { logError } from '@/helpers/log-helper';

function fetchCategory(_x, _x2, _x3) {
  return _fetchCategory.apply(this, arguments);
}

function _fetchCategory() {
  _fetchCategory = _asyncToGenerator(function* (context, alias, query) {
    let profileId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    const hash = extractCategoryHash(alias);
    const locale = context.state.i18n.currentLocale.iso;
    const {
      offset,
      limit,
      sortBy,
      orderBy,
      filterBy
    } = buildCategoryProductsQuery(query);

    try {
      const response = yield context.app.apolloProvider.defaultClient.query({
        query: categoryQuery,
        variables: {
          profileId,
          variantImageTransformation: process.client && context.$cookies.get('smart-crop-variants') ? 'g_auto,c_crop,r_max' : '',
          locale,
          hash,
          offset,
          limit,
          sortBy,
          orderBy,
          filterBy
        }
      });
      return response.data;
    } catch (e) {
      logError({
        msg: e,
        context
      });
      return null;
    }
  });
  return _fetchCategory.apply(this, arguments);
}

export { fetchCategory as default };